module.exports = __webpack_public_path__ + "img/CAN.2a5b8197.svg";